module.exports = __webpack_public_path__ + "static/media/la-overlook.a65ed333.jpg";